import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { LOGOUT } from '../../config/text/text';
import { Logout } from '../../helpers/logout';
import ThemeContext from '../../providers/ThemeProvider';
import useToast from '../_generic/toast/UseToast';

export const HeaderLogout = ({ setShowModal, extraClass }) => {
  const theme = useContext(ThemeContext);
  const toast = useToast();
  const dispatch = useDispatch();

  return (
    <>
      <li
        className={`logout-link ${extraClass}`}
        onClick={(event) => Logout(event, toast, dispatch, setShowModal)}
        onKeyPress={(event) => Logout(event, toast, dispatch, setShowModal)}
        role="menuitem"
      >
        {LOGOUT}
      </li>
      <style jsx>
        {`
          .logout-link {
            display: block;
            white-space: nowrap;
          }
          .navigation-link {
            color: ${theme.colors.navlink};
            padding: 5px 12px 5px 42px;
            text-transform: ${theme.text.navigation.transform};
            font-size: ${theme.text.navigation.size}px;
          }
          .navigation-link:focus {
            background-color: ${theme.colors.primary};
            color: ${theme.colors.textonprimary};
          }
        `}
      </style>
    </>
  );
};

HeaderLogout.propTypes = {
  extraClass: PropTypes.string,
  setShowModal: PropTypes.func,
};

HeaderLogout.defaultProps = {
  extraClass: '',
  setShowModal: () => false,
};
